import { gql } from "@apollo/client";

export const LANGUAGE_REPRESENTATIVE_DIPLOMA_FIELDS = gql`
  fragment LanguageRepresentativeDiplomaFields on LanguageRepresentativeDiploma {
    id
    firstname
    lastname
    personal_number
    place
    date
    educator1 {
      id
      name
      firstname
      lastname
      email
      type
    }
    educator2 {
      id
      name
      firstname
      lastname
      email
      type
    }
    educator3 {
      id
      name
      firstname
      lastname
      email
      type
    }

    author {
      id
      name
      type
    }
    college
    done
    created_at
    updated_at
    course_moment {
      id
      title
      type
      start_date
      end_date
      participants {
        id
        firstname
        lastname
      }
    }
    uid {
      id
      code
      created_at
    }
    collegeObject {
      id
      title
    }
  }
`;

export const GET_LANGUAGE_REPRESENTATIVE_DIPLOMA = gql`
  query LanguageRepresentativeDiploma($id: ID!, $categories: [String], $byPassMembership: Boolean) {
    certLanguageRepresentativeDiploma(id: $id) {
      ...LanguageRepresentativeDiplomaFields
    }
    allGroups(categories: $categories, byPassMembership: $byPassMembership) {
      id
      title
      parentGroups {
        logo3 {
          id
          title
          url
        }
      }
    }
  }
  ${LANGUAGE_REPRESENTATIVE_DIPLOMA_FIELDS}
`;

export const GET_LANGUAGE_REPRESENTATIVE_DIPLOMAS = gql`
  query LanguageRepresentativeDiplomas(
    $search: String
    $page: Int
    $limit: Int
    $orderBy: [GetLanguageRepresentativeDiplomasOrderByClause]
  ) {
    certLanguageRepresentativeDiplomas(
      search: $search
      page: $page
      limit: $limit
      orderBy: $orderBy
    ) {
      paginatorInfo {
        total
        currentPage
        hasMorePages
      }
      data {
        ...LanguageRepresentativeDiplomaFields
      }
    }
  }
  ${LANGUAGE_REPRESENTATIVE_DIPLOMA_FIELDS}
`;
